import "./pickup_request_management.scss";

let pickupRequestManagementComponent = {
  restrict: "E",
  bindings: {},
};

export default pickupRequestManagementComponent;



// WEBPACK FOOTER //
// ./client/app/components/pickup_request_management/pickup_request_management.component.js